import React, {ChangeEvent, useEffect, useRef, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface YearExpiryInputProps {
    yearExpiry: string;
    onSetYearExpiry: (yearExpiry: string) => void;
    onSetYearExpiryValid: (isYearExpiryValid: boolean) => void;
    isYearSelected: boolean;
}

export const YearExpiryInput: React.FunctionComponent<YearExpiryInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(false);
    const requiredYearExpiryError = 'Year expiry is a required field.';
    const invalidYearExpiryError = 'Year expiry field is invalid.';
    const inputRef = useRef<HTMLTextAreaElement>() as any;
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    useEffect(() => {
        if (props.isYearSelected && inputRef.current) {
            (inputRef.current as HTMLInputElement).focus();
        }
    }, [props.isYearSelected]);

    useEffect(() => {
        props.onSetYearExpiryValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        props.onSetYearExpiry(value);
        validateYearExpiry(undefined, value);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setIsSubmitted(true);
        validateYearExpiry();
    }

    const validateYearExpiry = (event: React.KeyboardEvent | undefined = undefined, year: string = '') => {
        year = year || props.yearExpiry;
        let errorsTemp: string[] = [];
        if (year === '') {
            errorsTemp.push(requiredYearExpiryError);
        }
        const yearAsNumber = parseFloat(year);
        if (!Number.isFinite(yearAsNumber) || yearAsNumber < (new Date().getFullYear() - 2000) || yearAsNumber > 99) {
            errorsTemp.push(invalidYearExpiryError);
        }
        setErrors(errorsTemp);
        const isValidTemp = errorsTemp.length === 0;
        setIsValid(isValidTemp);
    }

    return <div>
        <Input ref={inputRef} isValid={isValid} type='number' required={true} maxLength={2} value={props.yearExpiry}
               onChange={onChange}
               onBlur={onBlur} onKeyUp={validateYearExpiry}/>
        {isSubmitted && errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
